module.exports = __webpack_public_path__ + "img/close.90b28e68.svg";